import { execute } from '@/api/execute'
import { addQueryParams } from '@/util/index.js'
import { GET, PUT, POST } from '@/api/types'

const ENDPOINT = 'monitoring'

export default {

  farms (id) {
    return execute(GET, `${ENDPOINT}/farms/${id}/`)
  },

  updateFarms (id, data) {
    return execute(PUT, `${ENDPOINT}/farms/${id}/`, data)
  },

  ingredients (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/ingredients/`, params))
  },

  getIngredient (id) {
    return execute(GET, `${ENDPOINT}/ingredients/${id}/`)
  },

  updateIngredient (id, data) {
    return execute(PUT, `${ENDPOINT}/ingredients/${id}/`, data)
  },

  updateIngredientsBulk (data) {
    return execute(POST, `${ENDPOINT}/ingredients/bulk/`, data)
  },

  groups (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/groups/`, params))
  },

  getGroup (id) {
    return execute(GET, `${ENDPOINT}/groups/${id}/`)
  },

  updateGroup (id, data) {
    return execute(PUT, `${ENDPOINT}/groups/${id}/`, data)
  },

  updateGroupsBulk (data) {
    return execute(POST, `${ENDPOINT}/groups/bulk/`, data)
  }

}

